"use client";

import { FC, ReactNode } from "react";

import { Footer, MediaQuery } from "@/shared/components";
import { Loader, Tabs } from "@/shared/ui";
import { useOnboardingStore } from "stores/onboarding.store";

import { AuthHeader } from "../auth-header";

import {
  AccomplishmentsTab,
  ActivityTab,
  BirthdayTab,
  DescriptionTab,
  EmailVerificationTab,
  GeoTab,
  InstagramTab,
  NamesTab,
  PhoneTab,
  PhotoTab,
} from "./components";
import { useFetchMe } from "./components/names/hooks/use-fetch-me.hook";
import styles from "./onboarding-tabs.module.scss";

const STEPS_AMOUNT = 9;

const getStepToTab = (isEmailVerified?: boolean): Record<number, ReactNode> => {
  const baseTabs: ReactNode[] = [
    <NamesTab key="names" />,
    <BirthdayTab key="birthday" />,
    <PhoneTab key="phone" />,
    <InstagramTab key="instagram" />,
    <GeoTab key="geo" />,
    <ActivityTab key="activity" />,
    <PhotoTab key="photo" />,
    <DescriptionTab key="description" />,
    <AccomplishmentsTab key="accomplishments" />,
  ];

  const tabs = isEmailVerified === false ? [<EmailVerificationTab key="email" />, ...baseTabs] : baseTabs;

  return Object.fromEntries(tabs.map((tab, idx) => [idx, tab])) as Record<number, ReactNode>;
};

const OnboardingTabs: FC = () => {
  const currentStep = useOnboardingStore((state) => state.currentStep);
  const { setCurrentStep } = useOnboardingStore((state) => state.actions);
  const { data: userData, isFetching } = useFetchMe();

  const goBackHandler = () => {
    setCurrentStep(currentStep - 1);
  };

  const disableBack = currentStep === 0 || (userData?.isEmailVerified === false && currentStep === 1);

  return (
    <main className={styles.onboardingTabs}>
      <AuthHeader hints marginBottom={16} onClickBack={!disableBack ? () => goBackHandler() : undefined} />

      {isFetching ? (
        <div className={styles.loaderContainer}>
          <Loader border={4} size={32} theme="dark" />
        </div>
      ) : (
        <>
          <Tabs
            current={currentStep}
            stepsAmount={userData?.isEmailVerified ? STEPS_AMOUNT : STEPS_AMOUNT + 1}
            className={styles.tabs}
          />

          {getStepToTab(userData?.isEmailVerified)[currentStep]}
        </>
      )}

      <MediaQuery.Laptop>
        <Footer fixedAtBottom transparent />
      </MediaQuery.Laptop>
    </main>
  );
};

export { OnboardingTabs };
